window['MINSKY_DEV'] = (window['MINSKY_DEV'] || {});


/*
    Image Sizes
    -----------
    Little util script to quickly get image sizes when images are about to be opmtimized for different screensizes
    TIP: Use browsersync to sync multiple window sizes and get results even faster.
*/



(() => {
    const init = (config) => {
        if (config) {
            document.querySelectorAll('img:not(.dev--image-sizes').forEach($img => {
                $img.addEventListener('click', onImageClick);
            });

            console.info('MINSKY DEV: image-sizes ready.')
        }

        window['MINSKY_DEV'].imageSizes = init;
    }

    function onImageClick(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Image Size', decodeURI(e.currentTarget.src.split('/').pop()), ' -> ', e.currentTarget.clientWidth, 'x', e.currentTarget.clientHeight);
        e.currentTarget.classList.add('dev--image-sizes');
    }



    if (document.readyState === 'complete') {
        init(window['MINSKY_DEV'].imageSizes);
    }
    else {
        window.addEventListener('DOMContentLoaded', init.bind(window, window['MINSKY_DEV'].imageSize));
    }
})();


(() => {
    const init = (config) => {
        if (config) {
            Array.from(document.querySelectorAll('.image')).forEach(($img) => {
                console.log($img.className.split(' ')[1], $img.clientWidth, $img.clientHeight, $img.clientWidth / $img.clientHeight, )
            });
        }
    }


    if (document.readyState === 'complete') {
        init(window['MINSKY_DEV'].allImageSizesOnLoad);
    }
    else {
        window.addEventListener('DOMContentLoaded', init.bind(window, window['MINSKY_DEV'].allImageSizesOnLoad));
    }
})();